import { createContext } from 'react'

import { Paper } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'

export const EditPaperContext = createContext<{
  paper: Paper
  isRand: boolean
  limitLevel: number
}>(null as AnyType)
